module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-4-3.d6237b23.png";